<template>
<a :href="href" class="footer-btn" :class="`type-${type}`" :title="title"></a>
</template>
<script setup lang='ts'>
/*  IMPORTS  */

/*  VARIABLES  */
const props = defineProps<{
    href:string
    type:string
    title:string
}>()
/*  FUNCTIONS  */
</script>

<style lang="scss">
    .footer-btn{
        display: flex;
        width: 60px;
        height: 60px;
        background-repeat: no-repeat;
        background-position:center center;
        background-size: contain;
        transition: all .2s;
        &:hover{
            transform: scale(.9);
        }
        &.type-insta {
            background-image: url("~/assets/svgs/picto-insta.svg");
        }
        &.type-behance {
            background-image: url("~/assets/svgs/picto-behance.svg");
        }
        &.type-linkedin {
            background-image: url("~/assets/svgs/picto-linkedin.svg");
        }
    }
</style>